// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.bv-foot {
  position: relative;
  background:
    radial-gradient(900px 480px at 30% 0%,  rgba(20, 184, 166, 0.10), transparent 65%),
    radial-gradient(700px 380px at 85% 30%, rgba(254, 215, 170, 0.18), transparent 70%),
    var(--bv-bg-cream);
  border-top: 1px solid var(--bv-line-soft);
  padding-block: clamp(2.5rem, 5vw, 4rem) 1rem;
  overflow: hidden;

  /* Fade-in */
  opacity: 0;
  transform: translateY(28px);
  transition: opacity 0.9s var(--bv-ease-out), transform 1s var(--bv-ease-out);
}
.bv-foot.is-revealed {
  opacity: 1;
  transform: none;
}

/* =============== A. TOP CTA BLOCK =============== */
.bv-foot__cta-wrap {
  max-width: var(--bv-container-wide);
  margin-inline: auto;
  padding-inline: var(--bv-container-px);
  position: relative;
  z-index: 1;
}

.bv-foot__cta {
  position: relative;
  text-align: center;
}

.bv-foot__cta-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 18px;
  border-radius: var(--bv-radius-pill);
  background: #fff;
  border: 1px solid var(--bv-primary-line);
  color: var(--bv-primary-700);
  font-family: var(--bv-font-display);
  font-weight: 700;
  font-size: 0.78rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin-bottom: var(--bv-space-5);
  box-shadow: 0 4px 14px rgba(20, 184, 166, 0.16);
}
.bv-foot__cta-eyebrow i { color: var(--bv-primary); }

.bv-foot__cta-title {
  margin: 0 auto var(--bv-space-4);
  max-width: 720px;
}

.bv-foot__cta-lede {
  font-size: clamp(0.95rem, 1.4vw, 1.05rem);
  color: var(--bv-muted);
  line-height: 1.7;
  margin: 0 auto var(--bv-space-6);
  max-width: 580px;
}
.bv-foot__cta-lede strong {
  color: var(--bv-primary-700);
  font-weight: 800;
}

.bv-foot__cta-stores {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--bv-space-3);
}
.bv-foot__cta-store {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  color: var(--bv-primary-700);
  padding: 9px 18px;
  border-radius: var(--bv-radius);
  border: 1.5px solid var(--bv-primary-line);
  text-decoration: none;
  transition: transform var(--bv-dur) var(--bv-ease),
              background var(--bv-dur) var(--bv-ease),
              border-color var(--bv-dur) var(--bv-ease),
              box-shadow var(--bv-dur) var(--bv-ease);
  box-shadow: 0 8px 22px rgba(20, 184, 166, 0.14);
}
.bv-foot__cta-store i {
  font-size: 22px;
  line-height: 1;
  color: var(--bv-primary-700);
  transition: color var(--bv-dur) var(--bv-ease);
}
.bv-foot__cta-store span {
  display: flex;
  flex-direction: column;
  text-align: left;
  font-family: var(--bv-font-display);
  font-size: 0.94rem;
  font-weight: 800;
  line-height: 1.1;
  color: var(--bv-ink);
}
.bv-foot__cta-store em {
  font-style: normal;
  font-weight: 600;
  font-size: 9px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--bv-primary-700);
  margin-bottom: 2px;
  opacity: 0.85;
}
.bv-foot__cta-store:hover {
  transform: translateY(-3px);
  background: var(--bv-grad-primary);
  border-color: transparent;
  box-shadow: 0 14px 30px rgba(20, 184, 166, 0.36);
  color: #fff;
}
.bv-foot__cta-store:hover i,
.bv-foot__cta-store:hover span,
.bv-foot__cta-store:hover em { color: #fff; }

.bv-foot__cta-fan {
  position: relative;
  height: clamp(220px, 24vw, 340px);
  margin-bottom: 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  pointer-events: none;
  z-index: 1;
  mask-image: linear-gradient(180deg, transparent 0%, #000 8%, #000 55%, transparent 95%);
}

.bv-foot__phone {
  position: absolute;
  bottom: -100px;
  width: clamp(160px, 16vw, 220px);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  opacity: 0;
  filter: drop-shadow(0 20px 30px rgba(15, 23, 42, 0.18)) blur(2px);
  transition: opacity 0.7s var(--bv-ease-out),
              filter 0.7s var(--bv-ease-out),
              transform 0.7s var(--bv-ease-out);
}
.bv-foot__phone img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}

/* Fan positions */
.bv-foot__phone--p3 {
  z-index: 5;
  transform: translateY(-4%);
  width: clamp(200px, 20vw, 280px);
  filter: drop-shadow(0 30px 44px rgba(15, 23, 42, 0.22));
}

.bv-foot__phone--p2 {
  z-index: 4;
  transform: translateX(-73%) translateY(2%) rotate(-7deg);
}
.bv-foot__phone--p4 {
  z-index: 4;
  transform: translateX(73%) translateY(2%) rotate(7deg);
}

.bv-foot__phone--p1 {
  z-index: 3;
  transform: translateX(-142%) translateY(8%) rotate(-13deg);
  opacity: 0.7;
  /* Fade out from the inner side toward the outer side */
  mask-image: linear-gradient(90deg, transparent 0%, #000 60%);
}
.bv-foot__phone--p5 {
  z-index: 3;
  transform: translateX(142%) translateY(8%) rotate(13deg);
  opacity: 0.7;
  mask-image: linear-gradient(-90deg, transparent 0%, #000 60%);
}

/* Reveal animation: each phone fades + un-blurs in.
   We DON'T re-animate the static transform (translateX/rotate) so the fan stays. */
.bv-foot.is-revealed .bv-foot__phone {
  opacity: 1;
  filter: drop-shadow(0 20px 30px rgba(15, 23, 42, 0.18));
}
.bv-foot.is-revealed .bv-foot__phone--p1,
.bv-foot.is-revealed .bv-foot__phone--p5 { opacity: 0.7; }
.bv-foot.is-revealed .bv-foot__phone--p1 { transition-delay: 0.05s; }
.bv-foot.is-revealed .bv-foot__phone--p2 { transition-delay: 0.18s; }
.bv-foot.is-revealed .bv-foot__phone--p3 { transition-delay: 0.30s; }
.bv-foot.is-revealed .bv-foot__phone--p4 { transition-delay: 0.18s; }
.bv-foot.is-revealed .bv-foot__phone--p5 { transition-delay: 0.05s; }

.bv-foot__divider {
  max-width: var(--bv-container-wide);
  margin: clamp(1rem, 2vw, 1.5rem) auto var(--bv-space-7);
  border-top: 1px solid var(--bv-line);
  width: calc(100% - (var(--bv-container-px) * 2));
}

.bv-foot__cols-wrap {
  max-width: var(--bv-container-wide);
  margin-inline: auto;
  padding-inline: var(--bv-container-px);
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 2.6fr);
  gap: clamp(2rem, 4vw, 3rem);
}

/* Brand column */
.bv-foot__brand-col {
  max-width: 380px;
}

.bv-foot__brand {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  margin-bottom: var(--bv-space-3);
  line-height: 0;
}

.bv-foot__brand-logo {
  display: block;
  width: clamp(240px, 100%, 320px);
  height: auto;
  max-height: 80px;
  object-fit: contain;
  object-position: left center;
}

.bv-foot__brand-desc {
  color: var(--bv-muted);
  font-size: 0.9rem;
  line-height: 1.65;
  margin: 0 0 var(--bv-space-5);
}

.bv-foot__social {
  display: flex;
  gap: 8px;
}
.bv-foot__social a {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: var(--bv-primary-50);
  color: var(--bv-primary-700);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: transform var(--bv-dur) var(--bv-ease),
              background var(--bv-dur) var(--bv-ease),
              color var(--bv-dur) var(--bv-ease),
              box-shadow var(--bv-dur) var(--bv-ease);
  text-decoration: none;
  border: 1px solid var(--bv-primary-line);
}
.bv-foot__social a:hover {
  transform: translateY(-3px);
  background: var(--bv-primary);
  color: #fff;
  box-shadow: var(--bv-shadow-teal);
}

/* Link columns */
.bv-foot__cols {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: clamp(1.5rem, 3vw, 2.5rem);
}
.bv-foot__col h4 {
  font-family: var(--bv-font-display);
  font-size: 1rem;
  font-weight: 800;
  color: var(--bv-ink);
  letter-spacing: -0.01em;
  margin: 0 0 var(--bv-space-4);
}
.bv-foot__col ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.bv-foot__col button,
.bv-foot__col a {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: var(--bv-ink-3);
  font-size: 0.88rem;
  text-align: left;
  font-family: inherit;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: color var(--bv-dur) var(--bv-ease),
              transform var(--bv-dur) var(--bv-ease);
}
.bv-foot__col button:hover,
.bv-foot__col a:hover {
  color: var(--bv-primary-700);
  transform: translateX(3px);
}

.bv-foot__contact li {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  color: var(--bv-ink-3);
  font-size: 0.88rem;
  line-height: 1.5;
}
.bv-foot__contact li i {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: var(--bv-primary-50);
  color: var(--bv-primary-700);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  flex-shrink: 0;
  margin-top: 1px;
}
.bv-foot__contact a {
  color: var(--bv-ink-3);
  text-decoration: none;
  transition: color var(--bv-dur) var(--bv-ease);
}
.bv-foot__contact a:hover { color: var(--bv-primary-700); }

/* Payment logos — directly under footer logo */
.bv-foot__pay {
  margin-bottom: var(--bv-space-4);
}

.bv-foot__pay-logos {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 14px;
}

.bv-foot__pay-logos li {
  line-height: 0;
}

.bv-foot__pay-logos img {
  display: block;
  height: 32px;
  width: auto;
  max-width: 76px;
  object-fit: contain;
  object-position: left center;
  opacity: 0.95;
  transition: opacity var(--bv-dur) var(--bv-ease);
}

.bv-foot__pay-logos img:hover {
  opacity: 1;
}

/* ===== D. BOTTOM ===== */
.bv-foot__bottom {
  max-width: var(--bv-container-wide);
  margin: clamp(2rem, 4vw, 3rem) auto 0;
  padding: var(--bv-space-5) var(--bv-container-px) 0;
  border-top: 1px solid var(--bv-line-soft);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--bv-space-4);
  flex-wrap: wrap;
}
.bv-foot__bottom p {
  margin: 0;
  font-size: 0.82rem;
  color: var(--bv-muted);
}
.bv-foot__legal {
  display: flex;
  align-items: center;
  gap: 8px;
}
.bv-foot__legal button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 0.82rem;
  color: var(--bv-ink-3);
  font-family: inherit;
  transition: color var(--bv-dur) var(--bv-ease);
}
.bv-foot__legal button:hover { color: var(--bv-primary-700); }
.bv-foot__legal span { color: var(--bv-line); }

.bv-foot__credit {
  max-width: var(--bv-container-wide);
  margin: 0 auto;
  padding: var(--bv-space-4) var(--bv-container-px) var(--bv-space-6);
  text-align: center;
}
.bv-foot__credit p {
  margin: 0;
  font-size: 0.82rem;
  color: var(--bv-muted);
  line-height: 1.5;
}
.bv-foot__credit a {
  color: var(--bv-primary-700);
  font-weight: 600;
  text-decoration: none;
  transition: color var(--bv-dur) var(--bv-ease);
}
.bv-foot__credit a:hover {
  color: var(--bv-primary);
  text-decoration: underline;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 1100px) {
  .bv-foot__cols-wrap { grid-template-columns: 1fr; gap: 2rem; }
  .bv-foot__brand-col { max-width: none; }
  .bv-foot__cols { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1.5rem 1.25rem; }
}

@media (max-width: 992px) {
  .bv-foot__phone { width: clamp(140px, 18vw, 180px); }
  .bv-foot__phone--p3 { width: clamp(170px, 22vw, 220px); }
}
@media (max-width: 768px) {
  .bv-foot__pay-logos {
    gap: 10px 12px;
  }

  .bv-foot__pay-logos img {
    height: 26px;
    max-width: 64px;
  }

  .bv-foot__cols-wrap { gap: clamp(1.75rem, 5vw, 2.5rem); }
  .bv-foot__cols { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1.75rem 1.25rem; }
  .bv-foot__brand-col { max-width: none; }
  .bv-foot__cta-fan {
    height: 230px;
    mask-image: linear-gradient(180deg, transparent 0%, #000 6%, #000 68%, transparent 98%);
  }
  .bv-foot__phone {
    width: clamp(120px, 22vw, 155px);
    bottom: -100px;
  }
  .bv-foot__phone--p1,
  .bv-foot__phone--p5 { display: none; }
  .bv-foot__phone--p3 {
    width: clamp(150px, 28vw, 195px);
    transform: translateY(-4%);
  }
  .bv-foot__phone--p2 { transform: translateX(-54%) translateY(2%) rotate(-7deg); }
  .bv-foot__phone--p4 { transform: translateX(54%)  translateY(2%) rotate(7deg); }
  .bv-foot__cta-title { font-size: clamp(1.6rem, 5vw, 2.2rem); }
}

@media (max-width: 520px) {
  /* Keep TWO columns so links fill the width instead of stacking on one side */
  .bv-foot__cols { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1.5rem 1rem; }
  .bv-foot__cta-fan {
    height: 210px;
    mask-image: linear-gradient(180deg, transparent 0%, #000 5%, #000 70%, transparent 98%);
  }
  .bv-foot__phone {
    width: clamp(115px, 30vw, 140px);
    bottom: -100px;
  }
  .bv-foot__phone--p1,
  .bv-foot__phone--p5 { display: none; }
  .bv-foot__phone--p2,
  .bv-foot__phone--p4 { display: flex; }
  .bv-foot__phone--p3 {
    width: clamp(140px, 38vw, 175px);
    transform: translateY(-6%);
    z-index: 5;
  }
  .bv-foot__phone--p2 {
    transform: translateX(-62%) translateY(3%) rotate(-9deg);
    z-index: 4;
  }
  .bv-foot__phone--p4 {
    transform: translateX(62%) translateY(3%) rotate(9deg);
    z-index: 4;
  }
  .bv-foot__cta-stores { gap: 10px; }
  .bv-foot__cta-store { padding: 8px 12px; }
  .bv-foot__cta-store i { font-size: 18px; }
  .bv-foot__cta-store span { font-size: 0.82rem; }
  .bv-foot__bottom { justify-content: center; text-align: center; }
}

@media (max-width: 380px) {
  .bv-foot__cta-fan { height: 195px; }
  .bv-foot__phone { width: clamp(100px, 28vw, 125px); bottom: -100px; }
  .bv-foot__phone--p3 { width: clamp(125px, 36vw, 155px); }
  .bv-foot__phone--p2 { transform: translateX(-59%) translateY(4%) rotate(-8deg); }
  .bv-foot__phone--p4 { transform: translateX(59%) translateY(4%) rotate(8deg); }
}

@media (max-width: 360px) {
  .bv-foot__cols { grid-template-columns: 1fr; gap: 1.5rem; }
}
`, "",{"version":3,"sources":["webpack://./src/css/footer.css"],"names":[],"mappings":";;AAEA;EACE,kBAAkB;EAClB;;;sBAGoB;EACpB,yCAAyC;EACzC,4CAA4C;EAC5C,gBAAgB;;EAEhB,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,4EAA4E;AAC9E;AACA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,mCAAmC;EACnC,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;EAChB,wCAAwC;EACxC,4BAA4B;EAC5B,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,+CAA+C;AACjD;AACA,0BAA0B,wBAAwB,EAAE;;AAEpD;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,+BAA+B;EAC/B,0CAA0C;EAC1C,qBAAqB;EACrB;;;qDAGmD;EACnD,+CAA+C;AACjD;AACA;EACE,eAAe;EACf,cAAc;EACd,4BAA4B;EAC5B,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,yBAAyB;EACzB,gDAAgD;EAChD,WAAW;AACb;AACA;;+BAE+B,WAAW,EAAE;;AAE5C;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,UAAU;EAEF,uFAAuF;AACjG;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,UAAU;EACV,iEAAiE;EACjE;;+CAE6C;AAC/C;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,0BAA0B;EAC1B,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA;EACE,UAAU;EACV,wDAAwD;AAC1D;AACA;EACE,UAAU;EACV,sDAAsD;AACxD;;AAEA;EACE,UAAU;EACV,0DAA0D;EAC1D,YAAY;EACZ,uDAAuD;EAE/C,4DAA4D;AACtE;AACA;EACE,UAAU;EACV,wDAAwD;EACxD,YAAY;EAEJ,6DAA6D;AACvE;;AAEA;mFACmF;AACnF;EACE,UAAU;EACV,uDAAuD;AACzD;AACA;2CAC2C,YAAY,EAAE;AACzD,2CAA2C,uBAAuB,EAAE;AACpE,2CAA2C,uBAAuB,EAAE;AACpE,2CAA2C,uBAAuB,EAAE;AACpE,2CAA2C,uBAAuB,EAAE;AACpE,2CAA2C,uBAAuB,EAAE;;AAEpE;EACE,mCAAmC;EACnC,uDAAuD;EACvD,oCAAoC;EACpC,gDAAgD;AAClD;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,sDAAsD;EACtD,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf;;;qDAGmD;EACnD,qBAAqB;EACrB,wCAAwC;AAC1C;AACA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,WAAW;EACX,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,gDAAgD;EAChD,+BAA+B;AACjC;AACA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR;oDACkD;AACpD;AACA;;EAEE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,8CAA8C;AAChD;AACA,4BAA4B,4BAA4B,EAAE;;AAE1D,+CAA+C;AAC/C;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,UAAU;AACZ;;AAEA,0BAA0B;AAC1B;EACE,mCAAmC;EACnC,qCAAqC;EACrC,mDAAmD;EACnD,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,8CAA8C;AAChD;AACA,+BAA+B,4BAA4B,EAAE;AAC7D,uBAAuB,qBAAqB,EAAE;;AAE9C;EACE,mCAAmC;EACnC,cAAc;EACd,mEAAmE;EACnE,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,sBAAsB,0BAA0B,EAAE,SAAS,EAAE;EAC7D,sBAAsB,eAAe,EAAE;EACvC,iBAAiB,gDAAgD,EAAE,mBAAmB,EAAE;AAC1F;;AAEA;EACE,kBAAkB,gCAAgC,EAAE;EACpD,sBAAsB,gCAAgC,EAAE;AAC1D;AACA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA,sBAAsB,gCAAgC,EAAE;EACxD,iBAAiB,gDAAgD,EAAE,oBAAoB,EAAE;EACzF,sBAAsB,eAAe,EAAE;EACvC;IACE,aAAa;IAEL,uFAAuF;EACjG;EACA;IACE,gCAAgC;IAChC,cAAc;EAChB;EACA;wBACsB,aAAa,EAAE;EACrC;IACE,gCAAgC;IAChC,0BAA0B;EAC5B;EACA,sBAAsB,wDAAwD,EAAE;EAChF,sBAAsB,uDAAuD,EAAE;EAC/E,sBAAsB,qCAAqC,EAAE;AAC/D;;AAEA;EACE,6EAA6E;EAC7E,iBAAiB,gDAAgD,EAAE,gBAAgB,EAAE;EACrF;IACE,aAAa;IAEL,uFAAuF;EACjG;EACA;IACE,gCAAgC;IAChC,cAAc;EAChB;EACA;wBACsB,aAAa,EAAE;EACrC;wBACsB,aAAa,EAAE;EACrC;IACE,gCAAgC;IAChC,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,wDAAwD;IACxD,UAAU;EACZ;EACA;IACE,sDAAsD;IACtD,UAAU;EACZ;EACA,uBAAuB,SAAS,EAAE;EAClC,sBAAsB,iBAAiB,EAAE;EACzC,wBAAwB,eAAe,EAAE;EACzC,2BAA2B,kBAAkB,EAAE;EAC/C,mBAAmB,uBAAuB,EAAE,kBAAkB,EAAE;AAClE;;AAEA;EACE,oBAAoB,aAAa,EAAE;EACnC,kBAAkB,gCAAgC,EAAE,cAAc,EAAE;EACpE,sBAAsB,gCAAgC,EAAE;EACxD,sBAAsB,wDAAwD,EAAE;EAChF,sBAAsB,sDAAsD,EAAE;AAChF;;AAEA;EACE,iBAAiB,0BAA0B,EAAE,WAAW,EAAE;AAC5D","sourcesContent":["\n\n.bv-foot {\n  position: relative;\n  background:\n    radial-gradient(900px 480px at 30% 0%,  rgba(20, 184, 166, 0.10), transparent 65%),\n    radial-gradient(700px 380px at 85% 30%, rgba(254, 215, 170, 0.18), transparent 70%),\n    var(--bv-bg-cream);\n  border-top: 1px solid var(--bv-line-soft);\n  padding-block: clamp(2.5rem, 5vw, 4rem) 1rem;\n  overflow: hidden;\n\n  /* Fade-in */\n  opacity: 0;\n  transform: translateY(28px);\n  transition: opacity 0.9s var(--bv-ease-out), transform 1s var(--bv-ease-out);\n}\n.bv-foot.is-revealed {\n  opacity: 1;\n  transform: none;\n}\n\n/* =============== A. TOP CTA BLOCK =============== */\n.bv-foot__cta-wrap {\n  max-width: var(--bv-container-wide);\n  margin-inline: auto;\n  padding-inline: var(--bv-container-px);\n  position: relative;\n  z-index: 1;\n}\n\n.bv-foot__cta {\n  position: relative;\n  text-align: center;\n}\n\n.bv-foot__cta-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 18px;\n  border-radius: var(--bv-radius-pill);\n  background: #fff;\n  border: 1px solid var(--bv-primary-line);\n  color: var(--bv-primary-700);\n  font-family: var(--bv-font-display);\n  font-weight: 700;\n  font-size: 0.78rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  margin-bottom: var(--bv-space-5);\n  box-shadow: 0 4px 14px rgba(20, 184, 166, 0.16);\n}\n.bv-foot__cta-eyebrow i { color: var(--bv-primary); }\n\n.bv-foot__cta-title {\n  margin: 0 auto var(--bv-space-4);\n  max-width: 720px;\n}\n\n.bv-foot__cta-lede {\n  font-size: clamp(0.95rem, 1.4vw, 1.05rem);\n  color: var(--bv-muted);\n  line-height: 1.7;\n  margin: 0 auto var(--bv-space-6);\n  max-width: 580px;\n}\n.bv-foot__cta-lede strong {\n  color: var(--bv-primary-700);\n  font-weight: 800;\n}\n\n.bv-foot__cta-stores {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: var(--bv-space-3);\n}\n.bv-foot__cta-store {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  background: #fff;\n  color: var(--bv-primary-700);\n  padding: 9px 18px;\n  border-radius: var(--bv-radius);\n  border: 1.5px solid var(--bv-primary-line);\n  text-decoration: none;\n  transition: transform var(--bv-dur) var(--bv-ease),\n              background var(--bv-dur) var(--bv-ease),\n              border-color var(--bv-dur) var(--bv-ease),\n              box-shadow var(--bv-dur) var(--bv-ease);\n  box-shadow: 0 8px 22px rgba(20, 184, 166, 0.14);\n}\n.bv-foot__cta-store i {\n  font-size: 22px;\n  line-height: 1;\n  color: var(--bv-primary-700);\n  transition: color var(--bv-dur) var(--bv-ease);\n}\n.bv-foot__cta-store span {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  font-family: var(--bv-font-display);\n  font-size: 0.94rem;\n  font-weight: 800;\n  line-height: 1.1;\n  color: var(--bv-ink);\n}\n.bv-foot__cta-store em {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 9px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--bv-primary-700);\n  margin-bottom: 2px;\n  opacity: 0.85;\n}\n.bv-foot__cta-store:hover {\n  transform: translateY(-3px);\n  background: var(--bv-grad-primary);\n  border-color: transparent;\n  box-shadow: 0 14px 30px rgba(20, 184, 166, 0.36);\n  color: #fff;\n}\n.bv-foot__cta-store:hover i,\n.bv-foot__cta-store:hover span,\n.bv-foot__cta-store:hover em { color: #fff; }\n\n.bv-foot__cta-fan {\n  position: relative;\n  height: clamp(220px, 24vw, 340px);\n  margin-bottom: 0;\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  pointer-events: none;\n  z-index: 1;\n  -webkit-mask-image: linear-gradient(180deg, transparent 0%, #000 8%, #000 55%, transparent 95%);\n          mask-image: linear-gradient(180deg, transparent 0%, #000 8%, #000 55%, transparent 95%);\n}\n\n.bv-foot__phone {\n  position: absolute;\n  bottom: -100px;\n  width: clamp(160px, 16vw, 220px);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  opacity: 0;\n  filter: drop-shadow(0 20px 30px rgba(15, 23, 42, 0.18)) blur(2px);\n  transition: opacity 0.7s var(--bv-ease-out),\n              filter 0.7s var(--bv-ease-out),\n              transform 0.7s var(--bv-ease-out);\n}\n.bv-foot__phone img {\n  width: 100%;\n  height: auto;\n  display: block;\n  object-fit: contain;\n}\n\n/* Fan positions */\n.bv-foot__phone--p3 {\n  z-index: 5;\n  transform: translateY(-4%);\n  width: clamp(200px, 20vw, 280px);\n  filter: drop-shadow(0 30px 44px rgba(15, 23, 42, 0.22));\n}\n\n.bv-foot__phone--p2 {\n  z-index: 4;\n  transform: translateX(-73%) translateY(2%) rotate(-7deg);\n}\n.bv-foot__phone--p4 {\n  z-index: 4;\n  transform: translateX(73%) translateY(2%) rotate(7deg);\n}\n\n.bv-foot__phone--p1 {\n  z-index: 3;\n  transform: translateX(-142%) translateY(8%) rotate(-13deg);\n  opacity: 0.7;\n  /* Fade out from the inner side toward the outer side */\n  -webkit-mask-image: linear-gradient(90deg, transparent 0%, #000 60%);\n          mask-image: linear-gradient(90deg, transparent 0%, #000 60%);\n}\n.bv-foot__phone--p5 {\n  z-index: 3;\n  transform: translateX(142%) translateY(8%) rotate(13deg);\n  opacity: 0.7;\n  -webkit-mask-image: linear-gradient(-90deg, transparent 0%, #000 60%);\n          mask-image: linear-gradient(-90deg, transparent 0%, #000 60%);\n}\n\n/* Reveal animation: each phone fades + un-blurs in.\n   We DON'T re-animate the static transform (translateX/rotate) so the fan stays. */\n.bv-foot.is-revealed .bv-foot__phone {\n  opacity: 1;\n  filter: drop-shadow(0 20px 30px rgba(15, 23, 42, 0.18));\n}\n.bv-foot.is-revealed .bv-foot__phone--p1,\n.bv-foot.is-revealed .bv-foot__phone--p5 { opacity: 0.7; }\n.bv-foot.is-revealed .bv-foot__phone--p1 { transition-delay: 0.05s; }\n.bv-foot.is-revealed .bv-foot__phone--p2 { transition-delay: 0.18s; }\n.bv-foot.is-revealed .bv-foot__phone--p3 { transition-delay: 0.30s; }\n.bv-foot.is-revealed .bv-foot__phone--p4 { transition-delay: 0.18s; }\n.bv-foot.is-revealed .bv-foot__phone--p5 { transition-delay: 0.05s; }\n\n.bv-foot__divider {\n  max-width: var(--bv-container-wide);\n  margin: clamp(1rem, 2vw, 1.5rem) auto var(--bv-space-7);\n  border-top: 1px solid var(--bv-line);\n  width: calc(100% - (var(--bv-container-px) * 2));\n}\n\n.bv-foot__cols-wrap {\n  max-width: var(--bv-container-wide);\n  margin-inline: auto;\n  padding-inline: var(--bv-container-px);\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 2.6fr);\n  gap: clamp(2rem, 4vw, 3rem);\n}\n\n/* Brand column */\n.bv-foot__brand-col {\n  max-width: 380px;\n}\n\n.bv-foot__brand {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-start;\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  margin-bottom: var(--bv-space-3);\n  line-height: 0;\n}\n\n.bv-foot__brand-logo {\n  display: block;\n  width: clamp(240px, 100%, 320px);\n  height: auto;\n  max-height: 80px;\n  object-fit: contain;\n  object-position: left center;\n}\n\n.bv-foot__brand-desc {\n  color: var(--bv-muted);\n  font-size: 0.9rem;\n  line-height: 1.65;\n  margin: 0 0 var(--bv-space-5);\n}\n\n.bv-foot__social {\n  display: flex;\n  gap: 8px;\n}\n.bv-foot__social a {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  background: var(--bv-primary-50);\n  color: var(--bv-primary-700);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: transform var(--bv-dur) var(--bv-ease),\n              background var(--bv-dur) var(--bv-ease),\n              color var(--bv-dur) var(--bv-ease),\n              box-shadow var(--bv-dur) var(--bv-ease);\n  text-decoration: none;\n  border: 1px solid var(--bv-primary-line);\n}\n.bv-foot__social a:hover {\n  transform: translateY(-3px);\n  background: var(--bv-primary);\n  color: #fff;\n  box-shadow: var(--bv-shadow-teal);\n}\n\n/* Link columns */\n.bv-foot__cols {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: clamp(1.5rem, 3vw, 2.5rem);\n}\n.bv-foot__col h4 {\n  font-family: var(--bv-font-display);\n  font-size: 1rem;\n  font-weight: 800;\n  color: var(--bv-ink);\n  letter-spacing: -0.01em;\n  margin: 0 0 var(--bv-space-4);\n}\n.bv-foot__col ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.bv-foot__col button,\n.bv-foot__col a {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  color: var(--bv-ink-3);\n  font-size: 0.88rem;\n  text-align: left;\n  font-family: inherit;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: color var(--bv-dur) var(--bv-ease),\n              transform var(--bv-dur) var(--bv-ease);\n}\n.bv-foot__col button:hover,\n.bv-foot__col a:hover {\n  color: var(--bv-primary-700);\n  transform: translateX(3px);\n}\n\n.bv-foot__contact li {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  color: var(--bv-ink-3);\n  font-size: 0.88rem;\n  line-height: 1.5;\n}\n.bv-foot__contact li i {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  background: var(--bv-primary-50);\n  color: var(--bv-primary-700);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n.bv-foot__contact a {\n  color: var(--bv-ink-3);\n  text-decoration: none;\n  transition: color var(--bv-dur) var(--bv-ease);\n}\n.bv-foot__contact a:hover { color: var(--bv-primary-700); }\n\n/* Payment logos — directly under footer logo */\n.bv-foot__pay {\n  margin-bottom: var(--bv-space-4);\n}\n\n.bv-foot__pay-logos {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px 14px;\n}\n\n.bv-foot__pay-logos li {\n  line-height: 0;\n}\n\n.bv-foot__pay-logos img {\n  display: block;\n  height: 32px;\n  width: auto;\n  max-width: 76px;\n  object-fit: contain;\n  object-position: left center;\n  opacity: 0.95;\n  transition: opacity var(--bv-dur) var(--bv-ease);\n}\n\n.bv-foot__pay-logos img:hover {\n  opacity: 1;\n}\n\n/* ===== D. BOTTOM ===== */\n.bv-foot__bottom {\n  max-width: var(--bv-container-wide);\n  margin: clamp(2rem, 4vw, 3rem) auto 0;\n  padding: var(--bv-space-5) var(--bv-container-px) 0;\n  border-top: 1px solid var(--bv-line-soft);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--bv-space-4);\n  flex-wrap: wrap;\n}\n.bv-foot__bottom p {\n  margin: 0;\n  font-size: 0.82rem;\n  color: var(--bv-muted);\n}\n.bv-foot__legal {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.bv-foot__legal button {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-size: 0.82rem;\n  color: var(--bv-ink-3);\n  font-family: inherit;\n  transition: color var(--bv-dur) var(--bv-ease);\n}\n.bv-foot__legal button:hover { color: var(--bv-primary-700); }\n.bv-foot__legal span { color: var(--bv-line); }\n\n.bv-foot__credit {\n  max-width: var(--bv-container-wide);\n  margin: 0 auto;\n  padding: var(--bv-space-4) var(--bv-container-px) var(--bv-space-6);\n  text-align: center;\n}\n.bv-foot__credit p {\n  margin: 0;\n  font-size: 0.82rem;\n  color: var(--bv-muted);\n  line-height: 1.5;\n}\n.bv-foot__credit a {\n  color: var(--bv-primary-700);\n  font-weight: 600;\n  text-decoration: none;\n  transition: color var(--bv-dur) var(--bv-ease);\n}\n.bv-foot__credit a:hover {\n  color: var(--bv-primary);\n  text-decoration: underline;\n}\n\n/* ===== RESPONSIVE ===== */\n@media (max-width: 1100px) {\n  .bv-foot__cols-wrap { grid-template-columns: 1fr; gap: 2rem; }\n  .bv-foot__brand-col { max-width: none; }\n  .bv-foot__cols { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1.5rem 1.25rem; }\n}\n\n@media (max-width: 992px) {\n  .bv-foot__phone { width: clamp(140px, 18vw, 180px); }\n  .bv-foot__phone--p3 { width: clamp(170px, 22vw, 220px); }\n}\n@media (max-width: 768px) {\n  .bv-foot__pay-logos {\n    gap: 10px 12px;\n  }\n\n  .bv-foot__pay-logos img {\n    height: 26px;\n    max-width: 64px;\n  }\n\n  .bv-foot__cols-wrap { gap: clamp(1.75rem, 5vw, 2.5rem); }\n  .bv-foot__cols { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1.75rem 1.25rem; }\n  .bv-foot__brand-col { max-width: none; }\n  .bv-foot__cta-fan {\n    height: 230px;\n    -webkit-mask-image: linear-gradient(180deg, transparent 0%, #000 6%, #000 68%, transparent 98%);\n            mask-image: linear-gradient(180deg, transparent 0%, #000 6%, #000 68%, transparent 98%);\n  }\n  .bv-foot__phone {\n    width: clamp(120px, 22vw, 155px);\n    bottom: -100px;\n  }\n  .bv-foot__phone--p1,\n  .bv-foot__phone--p5 { display: none; }\n  .bv-foot__phone--p3 {\n    width: clamp(150px, 28vw, 195px);\n    transform: translateY(-4%);\n  }\n  .bv-foot__phone--p2 { transform: translateX(-54%) translateY(2%) rotate(-7deg); }\n  .bv-foot__phone--p4 { transform: translateX(54%)  translateY(2%) rotate(7deg); }\n  .bv-foot__cta-title { font-size: clamp(1.6rem, 5vw, 2.2rem); }\n}\n\n@media (max-width: 520px) {\n  /* Keep TWO columns so links fill the width instead of stacking on one side */\n  .bv-foot__cols { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1.5rem 1rem; }\n  .bv-foot__cta-fan {\n    height: 210px;\n    -webkit-mask-image: linear-gradient(180deg, transparent 0%, #000 5%, #000 70%, transparent 98%);\n            mask-image: linear-gradient(180deg, transparent 0%, #000 5%, #000 70%, transparent 98%);\n  }\n  .bv-foot__phone {\n    width: clamp(115px, 30vw, 140px);\n    bottom: -100px;\n  }\n  .bv-foot__phone--p1,\n  .bv-foot__phone--p5 { display: none; }\n  .bv-foot__phone--p2,\n  .bv-foot__phone--p4 { display: flex; }\n  .bv-foot__phone--p3 {\n    width: clamp(140px, 38vw, 175px);\n    transform: translateY(-6%);\n    z-index: 5;\n  }\n  .bv-foot__phone--p2 {\n    transform: translateX(-62%) translateY(3%) rotate(-9deg);\n    z-index: 4;\n  }\n  .bv-foot__phone--p4 {\n    transform: translateX(62%) translateY(3%) rotate(9deg);\n    z-index: 4;\n  }\n  .bv-foot__cta-stores { gap: 10px; }\n  .bv-foot__cta-store { padding: 8px 12px; }\n  .bv-foot__cta-store i { font-size: 18px; }\n  .bv-foot__cta-store span { font-size: 0.82rem; }\n  .bv-foot__bottom { justify-content: center; text-align: center; }\n}\n\n@media (max-width: 380px) {\n  .bv-foot__cta-fan { height: 195px; }\n  .bv-foot__phone { width: clamp(100px, 28vw, 125px); bottom: -100px; }\n  .bv-foot__phone--p3 { width: clamp(125px, 36vw, 155px); }\n  .bv-foot__phone--p2 { transform: translateX(-59%) translateY(4%) rotate(-8deg); }\n  .bv-foot__phone--p4 { transform: translateX(59%) translateY(4%) rotate(8deg); }\n}\n\n@media (max-width: 360px) {\n  .bv-foot__cols { grid-template-columns: 1fr; gap: 1.5rem; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
